module.exports = __webpack_public_path__ + "static/sportzone-8ef74f4c3bc420bdecff44bc6c27bb1b.svg";